export const CONSTANTS = {
  GRID_REPORT_COMPLETED: 'grid-report-completed',
  GRID_REPORT_LOOKUP: 'grid-report-lookup',
  LIST_ALL: 'list-report-all',
  REQUEST_DOWNLOAD: 'request-report-download',
  REQUEST_GENERATE: 'request-report-generate',
  REQUEST_GET_PARAMS: 'request-report-get-params',
  REQUEST_REFRESH: 'request-report-refresh',
  REQUEST_STATUS: 'request-report-status',
  REQUEST_REPORT_OBJECTS: 'request-report-objects',
  REQUEST_SET_PARAMS: 'request-report-set-params',
  SCREEN_GROUP: 'report',
} as const;
